import { InstallationReportStatus } from './installation-reporting-entities';

export enum GroupAgreementSections {
  PLOT_DESIGN = 'PLOT_DESIGN',
  PRE_INSTALLATION = 'PRE_INSTALLATION',
  PLOT_EXCAVATION = 'PLOT_EXCAVATION',
  DUCT_CONNECTING = 'DUCT_CONNECTING',
  CABLE_BLOWING = 'CABLE_BLOWING',
  SPLICING_MEASURING = 'SPLICING_MEASURING',
  COMMISSION = 'COMMISSION',
}

export enum SectionStatusStatuses {
  NOT_STARTED = 'NOT_STARTED',
  INCOMPLETE = 'INCOMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  EXECUTED = 'EXECUTED',
  PLANNED = 'PLANNED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum DeliveryStatus {
  MOJLIG = 'Mojlig',
  ESKALERAD = 'Eskalerad',
  INSTALLERAD_EJ_PORTKOPPLAD = 'Installerad_ej_portkopplad',
  BOM = 'Bom',
  EJ_VERIFIERAD = 'Ej verifierad',
  PAUSED_LINK = 'paused_link',
}

export enum ConstructionStatus {
  HANDED_TO_CONSTRUCTION = 'HANDED_TO_CONSTRUCTION',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  OBSTRUCTION = 'OBSTRUCTION',
  PLANNED = 'PLANNED',
  MIGRATION_ONGOING = 'MIGRATION_ONGOING',
  MIGRATED = 'MIGRATED',
}

export interface PaginationData {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  currentCount: number;
}

/** Aligns with live V3 section status shape */
export interface SectionStatus {
  section?: GroupAgreementSections | string;
  status?: SectionStatusStatuses | string | null;
  completedDate?: string | null;
  updatedAt?: string | null;
  updatedBy?: ContactInformation | string | null;
}

export type SectionStatuses = Partial<
  Record<string, SectionStatus | null | undefined>
>;

export interface Item {
  id: string;
  name: string;
  sectionStatuses: SectionStatuses;
  deliveryStatus?: string | null;
}

export interface Count {
  total: number;
  done: number;
}

/** Progress for a section, counted over buildings and delivery points. */
export interface SectionProgress {
  building?: Count | null;
  deliveryPoint?: Count | null;
}

export type SectionProgressMap = Record<
  string,
  SectionProgress | null | undefined
>;

export interface GroupAgreementsItem {
  id: string;
  name: string;
  sectionStatuses: SectionProgressMap;
  orderStatus?: InstallationReportStatus | string | null;
  constructionStatus?: ConstructionStatus | string | null;
  deliveryPointDelivered: Count | null;
}

export interface ContactInformation {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumberMobile?: string | null;
  phoneNumberHome?: string | null;
  email?: string | null;
}

export interface DeliveryPointStatusDetail {
  status?: SectionStatusStatuses | string | null;
  orderPlacedDate?: string;
  densificationDate?: string;
  annulmentDate?: string;
  remorseDate?: string;
  cancellationDate?: string;
  installationDate?: string;
  statusDate?: string;
}

export interface DeliveryPointsItem {
  id: string;
  address: string;
  buildingName?: string | null;
  buildingId?: string | null;
  installationDate?: string | null;
  sectionStatuses: SectionStatuses;
  deliveryStatus?: DeliveryStatus | string | null;
  deliveryPointStatus?: {
    status?: string | DeliveryPointStatusDetail | null;
    updatedAt?: string;
    updatedBy?: string;
  } | null;
  installationInformation?: {
    accessId?: string | null;
    macAddress?: string | null;
    macAddressNetadmin?: string | null;
  } | null;
}

export interface GroupAgreements extends PaginationData {
  items: GroupAgreementsItem[];
}

export interface GroupAgreementsDetails {
  propertyAddress?: string | null;
  propertyDesignation?: string | null;
  contactInformation?: ContactInformation | null;
  isResidentialNetwork?: boolean | null;
  networkType?: string | null;
  propertyConnection?: string | null;
  connectionType?: string | null;
  propertyNetwork?: string | null;
}

export interface Buildings extends PaginationData {
  items: Item[];
}

export interface DeliveryPoints extends PaginationData {
  items: DeliveryPointsItem[];
}
